import { Observable } from 'rxjs';
import { BaseUser } from './base-user.models';

export abstract class BaseAuthService {
  abstract getCurrentBaseUser(): Observable<BaseUser | undefined>;

  abstract getToken(): Promise<string>;

  abstract logout(): void;
}
